import React, { useState } from "react";
import { BsPlusLg } from "react-icons/bs";

export default function MultiAddedInput({ item, handleChangeTextAndCheckbox, tags, setTags }) {
    const [inputValue, setInputValue] = useState("");

    // const [sellerList, setSellerList] = useState([]);
    const handleAddTag = () => {
        if (inputValue.trim() !== "") {
            setTags([...tags, inputValue.trim()]);
            setInputValue("");
            handleChangeTextAndCheckbox([...tags, inputValue.trim()].join(","), item.question_id);
        }
    };

    const handleRemoveTag = (tagToRemove) => {
        const updatedTags = tags.filter((tag) => tag !== tagToRemove);
        setTags(updatedTags);
        handleChangeTextAndCheckbox(updatedTags.join(","), item.question_id);
    };

    return (
        <div className="tw-w-full tw-rounded-lg">
            {/* <label className="tw-block tw-text-gray-700 tw-font-semibold tw-mb-2">What is the seller name?</label> */}

            {/* Input and Add Button */}
            <div className="tw-flex tw-relative tw-w-full tw-items-center tw-space-x-2">
                <input
                    type="text"
                    placeholder="Enter name and press Add"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    className="tw-w-full tw-p-3 tw-bg-white tw-border-1 tw-rounded-lg tw-outline-none"
                />
                <button
                    onClick={handleAddTag}
                    disabled={inputValue ? false : true}
                    className="tw-absolute disabled:tw-cursor-not-allowed tw-right-1 tw-text-[25px] tw-leading-none tw-bg-background_color tw-text-gray-400 tw-p-2 tw-rounded-lg tw-border-gray-300 "
                >
                    <BsPlusLg />
                </button>
            </div>

            {/* Added Sellers List */}
            <div className="tw-mt-4 tw-flex tw-flex-wrap tw-gap-2">
                {tags.map((name, index) => (
                    <div key={index} className="tw-bg-white tw-py-1 tw-px-3 tw-rounded-md tw-flex tw-items-center">
                        <span className="tw-text-gray-500 tw-text-[12px]">{name}</span>
                        <button
                            onClick={() => handleRemoveTag(name)}
                            className="tw-ml-2  tw-text-gray-500 tw-font-bold tw-text-sm hover:tw-text-red-700"
                        >
                            ✕
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}
